import { css } from '@emotion/core'
import styled from '@emotion/styled'
import darken from 'polished/lib/color/darken'
import ReactModal from 'react-modal'

import { breakpoints, palette, spacing } from 'main/ui'

export type ModalKind = 'large' | 'normal'

export const Z_INDEX = 9

const modalWidths = {
  large: 960,
  normal: 555,
}

export const overlayStyles = css`
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${Z_INDEX};
`

export const StyledModal = styled(ReactModal)<{
  kind: ModalKind
  sideBar?: boolean
  height?: string
}>`
  background-color: ${palette.white};
  border-radius: 10px 10px 0 0;
  bottom: 0;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);
  left: 0;
  max-height: 100%;
  outline: none;
  overflow: auto;
  position: absolute;
  width: 100%;
  -webkit-overflow-scrolling: touch;

  @media (min-width: ${breakpoints.lg}px) {
    border-radius: ${({ sideBar }) => (sideBar ? '0px;' : '10px')};
    box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.25);
    margin: ${({ sideBar }) => (sideBar ? 'auto 0 auto auto' : '0 auto')};
    ${({ sideBar }) => (sideBar ? 'height: 100vh;' : 'height: auto;')}
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    width: ${({ kind }) => modalWidths[kind]}px;
    ${({ sideBar }) => (sideBar ? 'width: 400px;' : null)}
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.majorScale(4)}px;
  padding-top: ${spacing.majorScale(5)}px;

  @media (min-width: ${breakpoints.lg}px) {
    padding: ${spacing.majorScale(6)}px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${spacing.majorScale(2)}px;
  padding-bottom: ${spacing.majorScale(2)}px;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(2)}px;
  }
`

export const CrossIconContainer = styled.div`
  color: ${palette.chrome};
  cursor: pointer;
  margin-top: 6px;
  min-width: 16px;
  width: 16px;

  &:hover {
    color: ${darken(0.1, palette.chrome)};
  }

  @media (min-width: ${breakpoints.lg}px) {
    margin-top: 7px;
  }
`
